const defaultConsts = {
  userManagement: {
    defaultAdminUserName: 'admin',
  },
  localization: {
    defaultLocalizationSourceName: 'CZS',
  },
  authorization: {
    encrptedAuthTokenName: 'enc_auth_token',
  },
  appBaseUrl: 'http://localhost:8080',
  remoteServiceBaseUrl: 'http://192.168.1.43:6810',
  token_root: 'http://192.168.1.43:8086',
  response_type: 'id_token token',
  scope:
    'IdentityService VipService ProductService OrderService AlbumService MarketingService MallConfigService ArticleService DistributionService offline_access openid',
}

let env =
  process.env.NODE_ENV === 'development'
    ? 'development'
    : process.env.VUE_APP_TITLE === 'alpha'
    ? 'alpha'
    : 'production'
switch (env) {
  case 'development':
    // 测试站点
    defaultConsts.appBaseUrl = 'http://localhost:8080'
    defaultConsts.remoteServiceBaseUrl = 'https://order.api.deulife.com'
    defaultConsts.token_root = 'https://order.auth.deulife.com'
    break
  case 'production':
    // 正式站点
    defaultConsts.appBaseUrl = 'https://order.admin.deulife.com'
    defaultConsts.remoteServiceBaseUrl = 'https://order.api.deulife.com'
    defaultConsts.token_root = 'https://order.auth.deulife.com'
    break
  case 'alpha':
    // 测试站点
    defaultConsts.appBaseUrl = 'https://order.admin.deulife.com'
    defaultConsts.remoteServiceBaseUrl = 'https://order.api.deulife.com'
    defaultConsts.token_root = 'https://order.auth.deulife.com'

    break
}

export default defaultConsts
